/* eslint-disable no-shadow */
export enum ESizes {
  big = 'большой',
  average = 'средний',
  small = 'малый',
}

export enum EColors {
  white = 'белый',
  yellow = 'желтый',
  red = 'красный',
  blue = 'синий',
  green = 'зелёный',
}

export enum EShape {
  ball = 'шар',
  bell = 'колокольчик',
  cone = 'шишка',
  snowflake = 'снежинка',
  toy = 'фигурка',
}

export enum EColorGarland {
  multi = 'multi',
  red = 'red',
  green = 'green',
  blue = 'blue',
  yellow = 'yellow',
  off = 'off',
}

export type TTree = {
  number: string;
};
export type TColorGarland = keyof typeof EColorGarland;

export type TColors = keyof typeof EColors;

export type TSizes = keyof typeof ESizes;

export type TShape = keyof typeof EShape;

export type TToy = {
  num: string;
  name: string;
  count: string;
  year: string;
  shape: TShape;
  color: TColors;
  size: TSizes;
  favorite: boolean;
};

export const data: TToy[] = [
  {
    num: '1',
    name: 'Большой шар с рисунком',
    count: '2',
    year: '1960',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '2',
    name: 'Зелёный шар с цветами',
    count: '5',
    year: '2000',
    shape: 'ball',
    color: 'green',
    size: 'big',
    favorite: false,
  },
  {
    num: '3',
    name: 'Красный матовый шар',
    count: '3',
    year: '1990',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '4',
    name: 'Сосулька красная',
    count: '2',
    year: '1980',
    shape: 'toy',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '5',
    name: 'Красный виноград',
    count: '4',
    year: '1980',
    shape: 'toy',
    color: 'red',
    size: 'average',
    favorite: true,
  },
  {
    num: '6',
    name: 'Красный шар с рисунком',
    count: '6',
    year: '2010',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '7',
    name: 'Молочно-белый шар',
    count: '12',
    year: '1960',
    shape: 'ball',
    color: 'white',
    size: 'average',
    favorite: true,
  },
  {
    num: '8',
    name: 'Красный шар',
    count: '10',
    year: '2010',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '9',
    name: 'Колокольчик старинный',
    count: '2',
    year: '1950',
    shape: 'bell',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '10',
    name: 'Белый шар ретро',
    count: '7',
    year: '1960',
    shape: 'ball',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '11',
    name: 'Шишка еловая белая',
    count: '11',
    year: '1960',
    shape: 'cone',
    color: 'white',
    size: 'small',
    favorite: false,
  },
  {
    num: '12',
    name: 'Белый шар с цветами',
    count: '5',
    year: '1980',
    shape: 'ball',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '13',
    name: 'Шар расписной Река',
    count: '3',
    year: '1970',
    shape: 'ball',
    color: 'blue',
    size: 'big',
    favorite: true,
  },
  {
    num: '14',
    name: 'Шар расписной Деревня',
    count: '4',
    year: '1970',
    shape: 'ball',
    color: 'blue',
    size: 'big',
    favorite: true,
  },
  {
    num: '15',
    name: 'Колокольчик расписной',
    count: '3',
    year: '1970',
    shape: 'bell',
    color: 'blue',
    size: 'average',
    favorite: false,
  },
  {
    num: '16',
    name: 'Шишка расписная Пейзаж',
    count: '3',
    year: '1970',
    shape: 'cone',
    color: 'blue',
    size: 'average',
    favorite: true,
  },
  {
    num: '17',
    name: 'Шишка расписная',
    count: '7',
    year: '1970',
    shape: 'cone',
    color: 'red',
    size: 'average',
    favorite: false,
  },
  {
    num: '18',
    name: 'Желтый шар с бантом',
    count: '2',
    year: '2010',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '19',
    name: 'Желтый шар с паетками',
    count: '12',
    year: '1980',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '20',
    name: 'Красный шар с бантом',
    count: '8',
    year: '1950',
    shape: 'ball',
    color: 'red',
    size: 'average',
    favorite: true,
  },
  {
    num: '21',
    name: 'Красный шар с звёздами',
    count: '4',
    year: '1970',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: true,
  },
  {
    num: '22',
    name: 'Шишка еловая золотая',
    count: '11',
    year: '1990',
    shape: 'cone',
    color: 'yellow',
    size: 'small',
    favorite: false,
  },
  {
    num: '23',
    name: 'Колокольчик старинный',
    count: '9',
    year: '1950',
    shape: 'bell',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '24',
    name: 'Снежинка изящная',
    count: '1',
    year: '1940',
    shape: 'snowflake',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '25',
    name: 'Розовый шар с блёстками',
    count: '12',
    year: '2010',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '26',
    name: 'Рубиново-золотой шар',
    count: '8',
    year: '1960',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '27',
    name: 'Красный шар с узором',
    count: '4',
    year: '2010',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '28',
    name: 'Бордовый шар с узором',
    count: '10',
    year: '2010',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '29',
    name: 'Старинный шар с цветами',
    count: '5',
    year: '1950',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: true,
  },
  {
    num: '30',
    name: 'Старинный шар с узором',
    count: '8',
    year: '1950',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: true,
  },
  {
    num: '31',
    name: 'Красный шар с блёстками',
    count: '8',
    year: '2010',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '32',
    name: 'Синий шар Вселенная',
    count: '11',
    year: '1970',
    shape: 'ball',
    color: 'blue',
    size: 'big',
    favorite: false,
  },
  {
    num: '33',
    name: 'Синий шар со снежинкой',
    count: '6',
    year: '2010',
    shape: 'ball',
    color: 'blue',
    size: 'average',
    favorite: false,
  },
  {
    num: '34',
    name: 'Зелёный  шар с узором',
    count: '8',
    year: '2010',
    shape: 'ball',
    color: 'green',
    size: 'big',
    favorite: false,
  },
  {
    num: '35',
    name: 'Фигурка Лис в шарфе',
    count: '8',
    year: '1950',
    shape: 'toy',
    color: 'yellow',
    size: 'average',
    favorite: true,
  },
  {
    num: '36',
    name: 'Сиреневый шар Метель',
    count: '1',
    year: '2000',
    shape: 'ball',
    color: 'blue',
    size: 'big',
    favorite: false,
  },
  {
    num: '37',
    name: 'Зелёный  шар Метель',
    count: '6',
    year: '2000',
    shape: 'ball',
    color: 'green',
    size: 'big',
    favorite: false,
  },
  {
    num: '38',
    name: 'Голубой  шар Метель',
    count: '6',
    year: '2000',
    shape: 'ball',
    color: 'blue',
    size: 'big',
    favorite: false,
  },
  {
    num: '39',
    name: 'Красная снежинка',
    count: '6',
    year: '1990',
    shape: 'snowflake',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '40',
    name: 'Снежинка золотая',
    count: '12',
    year: '2020',
    shape: 'snowflake',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '41',
    name: 'Снежинка арктическая',
    count: '11',
    year: '2020',
    shape: 'snowflake',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '42',
    name: 'Зелёный шар',
    count: '10',
    year: '1980',
    shape: 'ball',
    color: 'green',
    size: 'average',
    favorite: false,
  },
  {
    num: '43',
    name: 'Снежинка двухцветная',
    count: '6',
    year: '1960',
    shape: 'snowflake',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '44',
    name: 'Фигурка Ангела',
    count: '11',
    year: '1940',
    shape: 'toy',
    color: 'red',
    size: 'average',
    favorite: true,
  },
  {
    num: '45',
    name: 'Снежинка новогодняя',
    count: '1',
    year: '1980',
    shape: 'snowflake',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '46',
    name: 'Фигурка Мухомор',
    count: '10',
    year: '1950',
    shape: 'toy',
    color: 'red',
    size: 'small',
    favorite: false,
  },
  {
    num: '47',
    name: 'Фигурка Колодец',
    count: '6',
    year: '1950',
    shape: 'toy',
    color: 'red',
    size: 'small',
    favorite: false,
  },
  {
    num: '48',
    name: 'Желтый шар с бантом',
    count: '6',
    year: '1960',
    shape: 'ball',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '49',
    name: 'Снежинка с бирюзой',
    count: '4',
    year: '1980',
    shape: 'snowflake',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '50',
    name: 'Колокольчик большой',
    count: '3',
    year: '2020',
    shape: 'bell',
    color: 'red',
    size: 'big',
    favorite: false,
  },
  {
    num: '51',
    name: 'Шишка с изморозью',
    count: '12',
    year: '1970',
    shape: 'cone',
    color: 'red',
    size: 'small',
    favorite: false,
  },
  {
    num: '52',
    name: 'Красный шар с надписью',
    count: '12',
    year: '1990',
    shape: 'ball',
    color: 'red',
    size: 'big',
    favorite: true,
  },
  {
    num: '53',
    name: 'Снежинка серебристая',
    count: '6',
    year: '2020',
    shape: 'snowflake',
    color: 'white',
    size: 'big',
    favorite: false,
  },
  {
    num: '54',
    name: 'Зелёный шар с рисунком',
    count: '6',
    year: '2010',
    shape: 'ball',
    color: 'green',
    size: 'big',
    favorite: false,
  },
  {
    num: '55',
    name: 'Пряничный домик',
    count: '1',
    year: '1940',
    shape: 'toy',
    color: 'yellow',
    size: 'big',
    favorite: false,
  },
  {
    num: '56',
    name: 'Пряничный теремок',
    count: '1',
    year: '1940',
    shape: 'toy',
    color: 'yellow',
    size: 'small',
    favorite: false,
  },
  {
    num: '57',
    name: 'Пряничная избушка',
    count: '1',
    year: '1940',
    shape: 'toy',
    color: 'yellow',
    size: 'average',
    favorite: false,
  },
  {
    num: '58',
    name: 'Фигурка белого медведя',
    count: '2',
    year: '1980',
    shape: 'toy',
    color: 'white',
    size: 'average',
    favorite: false,
  },
  {
    num: '59',
    name: 'Желтый шар с надписью',
    count: '10',
    year: '1990',
    shape: 'ball',
    color: 'yellow',
    size: 'average',
    favorite: false,
  },
  {
    num: '60',
    name: 'Фигурка Голубь',
    count: '12',
    year: '1940',
    shape: 'toy',
    color: 'white',
    size: 'average',
    favorite: true,
  },
];

export default data;
